import { styled } from '@mui/material';

export const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  flex: '1 1 0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
